import React from "react";

const DateBadge = ({ onClick, children }) => {
  return (
    <div
      className="cursor-pointer text-center w-2/4 px-6 py-2 my-2 mx-2 rounded-full bg-gray-400 hover:bg-gray-200 "
      onClick={onClick}
    >
      {children}
    </div>
  );
};

export default DateBadge;



// WEBPACK FOOTER //
// src/modules/presence/components/DateBadge.compontent.js